export default __webpack_public_path__ + "static/shape_heart-deb352fe2f718c3186203998060d4274.png";